
import React from 'react';
import { Camera, Coffee, Users, Map, Heart, Clock } from 'lucide-react';

const TourExpectations = () => {
  return (
    <section className="py-16 bg-[#FAF2E8]">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-playfair font-bold mb-8 text-[#8B4E2E] text-center">What You'll Experience</h2>
        <p className="text-lg text-center mb-12 max-w-3xl mx-auto">More than just facts and figures, our tours create moments that stay with you long after you've returned home.</p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="bg-white p-6 rounded-lg shadow-elegant">
            <div className="flex items-center mb-3">
              <Heart className="text-[#8B4E2E] mr-3" size={24} />
              <h3 className="text-xl font-semibold text-[#8B4E2E]">Emotional Connections</h3>
            </div>
            <p>Feel the thrill of discovery as you stand in the exact spot where legendary cats like Stubby supervised the Brooklyn Bridge construction. These stories connect you to the city in ways traditional tours simply can't.</p>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-elegant">
            <div className="flex items-center mb-3">
              <Coffee className="text-[#8B4E2E] mr-3" size={24} />
              <h3 className="text-xl font-semibold text-[#8B4E2E]">Hidden Gems Access</h3>
            </div>
            <p>Discover tucked-away courtyards and architectural details most New Yorkers walk past without noticing. Our routes reveal the secret spaces where cats made history, away from the typical tourist paths.</p>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-elegant">
            <div className="flex items-center mb-3">
              <Users className="text-[#8B4E2E] mr-3" size={24} />
              <h3 className="text-xl font-semibold text-[#8B4E2E]">Intimate Storytelling</h3>
            </div>
            <p>With our small group size, you'll experience personalized attention and the chance to ask questions. Imagine gathering around as your guide reveals vintage photographs of the very spot where you're standing.</p>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-elegant">
            <div className="flex items-center mb-3">
              <Camera className="text-[#8B4E2E] mr-3" size={24} />
              <h3 className="text-xl font-semibold text-[#8B4E2E]">Instagram-Worthy Moments</h3>
            </div>
            <p>Capture unique photos of historic cat sculptures, quirky street art, and charming neighborhood vistas that will make your social media followers wonder how they missed these spots on their own NYC visits.</p>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-elegant">
            <div className="flex items-center mb-3">
              <Map className="text-[#8B4E2E] mr-3" size={24} />
              <h3 className="text-xl font-semibold text-[#8B4E2E]">New Perspectives</h3>
            </div>
            <p>Even lifelong New Yorkers tell us they see their city differently after our tour. By looking at history through the lens of its feline inhabitants, familiar landmarks transform into scenes of forgotten stories waiting to be rediscovered.</p>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-elegant">
            <div className="flex items-center mb-3">
              <Clock className="text-[#8B4E2E] mr-3" size={24} />
              <h3 className="text-xl font-semibold text-[#8B4E2E]">Lasting Memories</h3>
            </div>
            <p>Two hours with us becomes stories you'll tell for years. "Remember that cat who saved Wall Street?" becomes part of your personal connection to New York—a special memory that goes beyond the typical Empire State Building photo.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TourExpectations;
